import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    page: 1,
    selectedValue: 10,
    activeTab: 0,
    ApprovalsFormValue: {
        raised_on: "",
        raised_by: "",
        all_approvals: 0,
        name: "",
    },
    selectedMetric: null as { id: number; name: string } | null,
    displayValues: [] as { id: number; name: string }[],
    currentRules: [] as { id: number; name: string }[],
    visibleColumns: [
        { name: "Raised On", visible: false },
        { name: "Raised By", visible: false },
    ] as { name: string; visible: boolean }[],
}

const ApprovalsSlice = createSlice({
    name: "Approvals",
    initialState,
    reducers: {
        setApprovalsForm: (state, action) => {
            state.ApprovalsFormValue = { ...state.ApprovalsFormValue, ...action.payload }
        },
        setApprovalsPage: (state, action) => {
            state.page = action.payload
        },
        setApprovalsSelectedValue: (state, action) => {
            state.selectedValue = action.payload
        },
        setApprovalsDisplayValues: (state, action) => {
            state.displayValues = action.payload
        },
        setApprovalsCurrentRules: (state, action) => {
            state.currentRules = action.payload
        },
        setSelectedMetric: (state, action) => {
            state.selectedMetric = action.payload
        },
        setVisibleColumns: (state, action) => {
            state.visibleColumns = action.payload
        },
        setApprovalsActiveTab: (state, action) => {
            state.activeTab = action.payload
        },
        resetApprovalsForm: state => {
            state.ApprovalsFormValue = {
                ...initialState.ApprovalsFormValue,
                all_approvals: state.ApprovalsFormValue.all_approvals,
            }
            state.selectedMetric = null
            state.displayValues = []
            state.currentRules = []
            state.page = 1
        },
    },
})

export const {
    setApprovalsForm,
    setApprovalsPage,
    setApprovalsSelectedValue,
    setApprovalsDisplayValues,
    setApprovalsCurrentRules,
    setSelectedMetric,
    setVisibleColumns,
    setApprovalsActiveTab,
    resetApprovalsForm,
} = ApprovalsSlice.actions

export default ApprovalsSlice.reducer
